import axios from '@/src/api/axios_init'
import { queryClient } from '@/src/api/queryClient'
import { API } from '../api/api'
import { queryKeys } from '../api/queryKeys'
import type { InvitedUser } from '../features/user-management/types/invitedUser.interface'
import { ECOPLANET_DOMAIN } from '../utils/constants'
import { getLocation } from './infrastructureDataProvider'

export const updateCompany = async (companyId, updateObj) => {
  await axios.patch(`/firebase/company?companyId=${companyId}`, {
    updateObj,
  })
}

export const updateUser = async (userId, companyId, updateObj) => {
  const endpoint = `/users/frontend/${userId}`
  await axios.patch(endpoint, {
    ...updateObj,
    companyId,
  })
  void queryClient.invalidateQueries({
    queryKey: queryKeys.users.toKey(),
  })
}

export const getRegisteredLocationUsers = async locationFirebaseId => {
  const users = await API.users.fetch({ locationFirebaseId })
  return users.filter(item => !item.email.endsWith(ECOPLANET_DOMAIN))
}

export const getRegisteredAndInvitedUsers = async (locationFirebaseId: string) => {
  const [locationUsers, company] = await Promise.all([getRegisteredLocationUsers(locationFirebaseId), getLocation(locationFirebaseId)])
  const invitedUsers = getInvitedUsers(company)
  return (locationUsers as any[]).concat(invitedUsers)
}

export const getInvitedUsers = company => {
  if (!company) return []
  const { invitedUsers } = company as any

  let result: InvitedUser[] = []

  if (invitedUsers?.length) {
    result = invitedUsers.map(user => {
      return { isInvited: true, ...user }
    })
  }

  return result
}
